import React from 'react';
import KnowledgeComponent from './KnowledgeComponent';

const BusinessGlossary = () => {
  return <KnowledgeComponent mainView="businessGlossary" />;
};

export default BusinessGlossary;
